import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common
  },
  mutations: {
    // 重置vuex本地储存状态
    resetStore (state) {
      state.common.menuList = []
      state.common.mainTabs = []
    }
  },
  strict: process.env.NODE_ENV !== 'production'
})



// WEBPACK FOOTER //
// ./src/store/index.js